import { PasswordResponses } from "react-pdf";

export interface FullScreenDocument extends Document {
  // Fullscreen elements
  mozFullScreenElement?: Element;
  webkitFullscreenElement?: Element;
  msFullscreenElement?: Element;
  // Exit fullscreen methods
  mozCancelFullScreen?: () => Promise<void> | void;
  webkitExitFullscreen?: () => Promise<void> | void;
  msExitFullscreen?: () => Promise<void> | void;
}

export interface FullScreenElement extends HTMLElement {
  mozRequestFullscreen?: () => Promise<void> | void;
  webkitRequestFullscreen?: () => Promise<void> | void;
  msRequestFullscreen?: () => Promise<void> | void;
}

export type PdfViewerState = {
  numPages: number;
  pageNumber: number;
  isLoading: boolean;
  pageWidth: number;
  pageHeight?: number;
  scale: number;
};

export enum PdfViewerStateActions {
  SetNumPages = "SetNumPages",
  SetPageNumber = "setPageNumber",
  SetIsLoading = "setIsLoading",
  SetPageDimensions = "setPageDimensions",
  ZoomIn = "zoomIn",
  ZoomOut = "zoomOut",
}

export type PdfViewerStateAction =
  | { type: PdfViewerStateActions.SetNumPages; payload: { numPages: number } }
  | { type: PdfViewerStateActions.SetPageNumber; payload: { pageNumber: number } }
  | { type: PdfViewerStateActions.SetIsLoading; payload: { isLoading: boolean } }
  | {
      type: PdfViewerStateActions.SetPageDimensions;
      payload: { pageWidth: number; pageHeight?: number };
    }
  | { type: PdfViewerStateActions.ZoomIn }
  | { type: PdfViewerStateActions.ZoomOut };

// Password types got from 'react-pdf'
export type PasswordResponse = (typeof PasswordResponses)[keyof typeof PasswordResponses];
export type OnPasswordCallback = (password: string | null) => void;

export type PasswordFormData = {
  password: string;
};
